<!-- components/PaymentOptionCard.vue -->
<template>
  <div class="payment-option-card" @click="$emit('select')">
    <img class="payment-option-card__image" :src="imgSrc" alt="">
    <h3 class="payment-option-card__title">{{ title }}</h3>
    <p class="payment-option-card__description">{{ description }}</p>
  </div>
</template>

<script setup lang="ts">
defineProps<{
  title: string
  description: string
  imgSrc: string
}>()
</script>

<style scoped lang="scss">
.payment-option-card {
  border: 2px solid transparent;
  border-radius: 20px;
  padding: 20px;
  transition: all 0.2s ease;
  background: #f7f9fa;
  cursor: pointer;
  display: flex;
  gap: 8px;
  align-items: center;

  @include mobile {
    align-items: start;
    flex-direction: column;
  }
}

.payment-option-card__image {
  object-fit: contain;
  width: 100%;
  max-width: 70px;
  max-height: 70px;
  margin-right: 12px;
  flex: 2;
}

.payment-option-card:hover {
  border: 2px solid #cbdbf7;
  background-color: #f3f5f7;
}

.payment-option-card__title {
  font-weight: 600;
  font-size: 18px;
  line-height: 135%;
  color: #000;
  margin-bottom: 0;
  max-width: 332px;
  width: 100%;
  flex: 1;
}

.payment-option-card__description {
  font-weight: 400;
  font-size: 14px;
  line-height: 150%;
  color: #58595a;
  flex: 1;
}
</style>